/**
 * Created by Ivan on 10.08.2026
 */

const PuzzleStickerView2 = function (sticker, options) {
    options = options || {};

    return Prefab.instantiate(bundles.sticker2.jsons.puzzle_sticker_prefab_json, {
        sticker,
        placeholder: options.placeholder,
        withUpdate: options.withUpdate
    });
};
